import { initTranslation } from "./modules/i18n";
import { WithAuth } from "./modules/auth/WithAuth";
import WithAxios from "./modules/axios/WithAxios";
import { ConfigContainer } from "./modules/config";

const DEFAULT_LANGUAGE = "en";

initTranslation(DEFAULT_LANGUAGE);

export const App = () => {
  return (
    <ConfigContainer>
      <WithAuth>
        <WithAxios />
      </WithAuth>
    </ConfigContainer>
  );
};
